/** Guida operativa del promemoria mensile: un passo per piattaforma. */
export const CHAT_CLAUDE_BANCA = 'https://claude.ai/share/d6d2107f-0955-45b0-841c-09eb0f156d86';
export const MAIL_ACQUISTI = ['e.garoli@winp.co', 'amministrazione@winp.co'];

export const oggettoMail = (labelMese) => `Richiesta fatture XML ${labelMese.toUpperCase()}`;

export const testoMail = () =>
  'Ciao Eleonora,\n'
  + 'ti chiedo cortesemente di inviarmi da Digital Hub le fatture relative al mese appena '
  + 'trascorso, scaricate in formato XML e raccolte in un unico file ZIP.\n'
  + 'Grazie.\n'
  + 'Amedeo';

export const PASSI = [
  {
    chiave: 'mail_acquisti',
    tipo: 'manuale',
    titolo: 'Chiedi le fatture XML a WINP',
    fonte: 'Mail',
    spunta: 'Mail inviata',
    istruzioni: [
      'Scrivi a e.garoli@winp.co e amministrazione@winp.co chiedendo le fatture del mese appena concluso, scaricate da Digital Hub in formato XML e raccolte in un unico file ZIP.',
    ],
  },
  {
    chiave: 'acquisti_xml',
    tipo: 'auto',
    titolo: 'Carica lo ZIP delle fatture XML',
    fonte: 'Digital Hub Zucchetti',
    link: { path: '/acquisti/carica', label: 'Vai a Carica fatture' },
    istruzioni: [
      'Quando arriva il file ZIP caricalo così com\'è: l\'app apre lo ZIP, sbusta le fatture firmate (.p7m) e salta quelle già presenti.',
    ],
  },
  {
    chiave: 'personale',
    tipo: 'auto',
    titolo: 'Scarica il costo del personale da Zucchetti',
    fonte: 'Zucchetti — Statistica costo orario',
    link: { path: '/acquisti/personale', label: 'Vai a Personale' },
    istruzioni: [
      'Percorso: SPAZIO MARCONI > AREA DEL PERSONALE > REPORT > COSTI DEL PERSONALE > Statistica costo orario.',
      'È questo il documento da caricare. Riepilogo paghe e Libro unico servono solo per controlli e riconciliazioni.',
    ],
  },
  {
    chiave: 'bancari_csv',
    tipo: 'manuale',
    titolo: 'Scarica le uscite dall\'home banking',
    fonte: 'Home banking (CSV)',
    spunta: 'Excel pronto',
    link: { url: CHAT_CLAUDE_BANCA, label: 'Apri la chat che prepara l\'Excel' },
    istruzioni: [
      'Scarica in CSV tutte le uscite del mese appena concluso.',
      'Caricalo nella chat dedicata e fatti creare il file Excel nel formato corretto per l\'importazione.',
    ],
  },
  {
    chiave: 'bancari',
    tipo: 'auto',
    titolo: 'Carica l\'Excel dei costi bancari',
    fonte: 'Excel elaborato',
    link: { path: '/acquisti/bancari', label: 'Vai a Bancari' },
    istruzioni: [
      'Carica il file Excel: l\'app legge il primo foglio e mostra l\'anteprima prima di salvare.',
    ],
  },
  {
    chiave: 'venduto',
    tipo: 'auto',
    titolo: 'Scarica il venduto da Cassa in Cloud',
    fonte: 'Cassa in Cloud — DOCUMENTI > VENDITE',
    link: { path: '/venduto/caricamento', label: 'Vai a Carica venduto' },
    istruzioni: [
      'Scarica i file del mese appena concluso per scontrini, fatture e proforma.',
      'Caricali tutti e tre insieme: il consolidamento sostituisce integralmente le giornate del tipo caricato.',
    ],
  },
  {
    chiave: 'controllo_finale',
    tipo: 'manuale',
    titolo: 'Controllo finale del mese',
    fonte: 'Verifica',
    spunta: 'Mese verificato',
    link: { path: '/acquisti/dashboard', label: 'Apri la dashboard' },
    istruzioni: [
      'Verifica di avere caricato: fatture XML degli acquisti, costo del personale da Zucchetti, uscite bancarie in Excel, scontrini + fatture + proforma da Cassa in Cloud.',
      'A questo punto il mese è completo e può essere analizzato nel controllo di gestione.',
    ],
  },
];
